import { applicationContextActionCreator } from '../store/actions';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import ServiceBase from './ServiceBase';

class CodingMetricsService extends ServiceBase {

    async getEventMetricsAdminDashboard(accountIds, queueIds, assignedToId, fetchRefData) {
        var result = await this.requestJson({
            url: `/api/metrics/admin`,
            method: "POST",
            data: { "accountIds": accountIds, "queueIds": queueIds, "assignedToId": assignedToId, "fetchRefData": fetchRefData }
        });
        return result;
    }

    async getEventMetricsTeamLeadDashboard(accountIds, queueIds, assignedToId, fetchRefData) {
        var result = await this.requestJson({
            url: `/api/metrics/teamlead`,
            method: "POST",
            data: { "accountIds": accountIds, "queueIds": queueIds, "assignedToId": assignedToId, "fetchRefData": fetchRefData }
        });
        return result;
    }

    async getEventMetricsCoderDashboard(accountIds, queueIds, assignedToId, fetchRefData) {
        var result = await this.requestJson({
            url: `/api/metrics/coder`,
            method: "POST",
            data: { "accountIds": accountIds, "queueIds": queueIds, "assignedToId": assignedToId, "fetchRefData": fetchRefData }
        });
        return result;
    }
}

export default CodingMetricsService;